import QuilityAPI from '@/store/API/QuilityAPI.js'

const createScript = () => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = 'https://js.stripe.com/basil/stripe.js'
		script.async = true
		script.onload = resolve
		script.onerror = reject
		document.head.appendChild(script)
	})
}

let instance
let checkout

export default {
	install (app) {
		app.prototype.$stripe = {
			async initialize () {
				try {
					if (!window.Stripe) {
						await createScript()
						console.log('[Stripe] Script loaded.')
					}
				} catch (e) {
					console.error('[Stripe] Failed to load script.<br>', e)
				}
			},

			fetchClientSecret (data) {
				return async () => {
					try {
						const { client_secret } = await QuilityAPI.getStripeClientSecret(data)
						return client_secret
					} catch (e) {
						console.error('[Stripe] Failed to load client secret.<br>', e)
					}
				}
			},

			async initCheckout (data, editMode = false) {
				const stripe = await this.getStripe(editMode)
				if (checkout) {
					await checkout.destroy()
				}
				checkout = await stripe.initEmbeddedCheckout({
					fetchClientSecret: this.fetchClientSecret({ ...data, editMode }),
				})
				return checkout
			},

			async getStripe (editMode = false) {
				if (!instance) {
					await this.initialize()
					let API_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
					if (process.env.NODE_ENV !== "development" && editMode) {
						// API_KEY = process.env.VUE_APP_STRIPE_DEV_PUBLISHABLE_KEY
						API_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
					}
					instance = window.Stripe(API_KEY)
				}
				return instance
			},
		}
	}
}
